var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('widget',{attrs:{"widget-id":_vm.widgetId,"title":_vm.getTitle(),"icon":"chart-pie"}},[_c('svg',{ref:"svg"})])}
var staticRenderFns = []

export { render, staticRenderFns }